import { render, staticRenderFns } from "./ver_reagendamento_especialidade.vue?vue&type=template&id=2ed6ffd4&scoped=true&"
import script from "./ver_reagendamento_especialidade.vue?vue&type=script&lang=js&"
export * from "./ver_reagendamento_especialidade.vue?vue&type=script&lang=js&"
import style0 from "./ver_reagendamento_especialidade.vue?vue&type=style&index=0&id=2ed6ffd4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ed6ffd4",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardActions } from 'vuetify/lib/components/VCard';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
import { VToolbar } from 'vuetify/lib/components/VToolbar';
import { VToolbarItems } from 'vuetify/lib/components/VToolbar';
import { VToolbarTitle } from 'vuetify/lib/components/VToolbar';
installComponents(component, {VBtn,VCard,VCardActions,VIcon,VProgressCircular,VSelect,VSpacer,VTextField,VToolbar,VToolbarItems,VToolbarTitle})
